import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  fetchIndividualData,
  fetchOrganizationData,
} from "../../../../../API/ClevDocContact";
import { decodeJwtToken } from "../../../../../CommonFunction/TokenDecode";
import { useNavigate } from "react-router-dom";
import cookies from "../../../../../CommonFunction/cookies";
import {
  showFailed,
  showWarning,
} from "../../../../../CommonFunction/SweetAlert";
import Loader, { DashboardLoading } from "../../../../../CommonFunction/Loader";
import Widget from "../../Pages/Widget";
import Calendar from "react-calendar";
import {
  BorrowerDashboardDetails,
  BorrowerNotification,
  BorrowerNotificationById,
} from "../../../../../API/Borrower/Dashboard/Dashboard";
import {
  formatDate,
  formatDate2,
} from "../../../../../CommonFunction/FormatedDate";
import { IoIosNotifications } from "react-icons/io";
import NotificationModal from "./NotificationModal";

const BorrowerDashboard = () => {
  const observer = useRef();
  const hasMoreRef = useRef(true);
  const [value, onChange] = useState(new Date());
  const [userData, setUserData] = useState(null);
  const jwtToken = cookies.get("jwt");
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({});
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [messageOpen, setMessageOpen] = useState(false);
  const [message, setMessage] = useState([]);
  const [messageById, setMessageById] = useState([]);
  const [name, setName] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState();
  const [loadingMore, setLoadingMore] = useState(false);

  const fetchDataAndUpdateUserData = async () => {
    try {
      const data = await fetchIndividualData(jwtToken);
      setUserData(data);
      CheckComponent(data);
    } catch (error) {
      console.error("Error retrieving user data:", error);
    }
  };

  const fetchOrgDataAndUpdate = async () => {
    try {
      const data = await fetchOrganizationData(jwtToken);
      setUserData(data);
      CheckComponent(data);
    } catch (error) {
      console.error("Error retrieving organization data:", error);
    }
  };

  const fetchDashboardDetails = async () => {
    setIsLoading(true);
    try {
      const data = await BorrowerDashboardDetails(jwtToken);
      setDashboardData(data?.response);
    } catch (error) {
      showFailed("Failed.", `${error}`);
    }
    setIsLoading(false);
  };

  const fetchNotification = async (pageNum = 1) => {
    try {
      const data = await BorrowerNotification(jwtToken, pageNum);
      if (pageNum === 1) {
        setMessage(data.response);
      } else {
        setMessage((prev) => ({
          ...data.response,
          docs: [...prev.docs, ...data.response.docs],
        }));
      }
  
      const more = data?.response?.hasNextPage;
      setHasMore(more);
      hasMoreRef.current = more;
    } catch (error) {
      showFailed("Failed.", `${error}`);
    }
  };       

  const fetchNotificationById = async (id, read) => {
    try {
      const data = await BorrowerNotificationById(jwtToken, id);
      console.log("Notification By ID data is here: ", data?.data);
      setMessageById(data?.data);
      console.log("Notigifkvdfjvn -nnj---", read);
      if (read === false && data?.data?.read) {
        fetchNotification(1);
      }
    } catch (error) {
      showFailed("Failed.", `${error}`);
    }
  };

  function CheckComponent(userData) {
    if (userData && userData?.step === 1) {
      showWarning(
        "Profile Incomplete...",
        "Your Profile is not completed, please complete your profile first"
      );
      if (data.role === "entity") {
        navigate("/banking/borrowerDashboard/2");
      } else if (data.role === "user") {
        navigate("/banking/borrowerDashboard/1");
      }
    } else if (userData && userData?.step === 2 && !userData.payment) {
      showWarning(
        "Payment Incomplete...",
        "Your Payment is not completed, please complete your Payment first"
      );
      navigate("/banking/purchaseSummary");
    } else {
      fetchDashboardDetails();
    }
  }

  useEffect(() => {
    let mounted = true;
    setPage(1);
    const fetchData = async () => {
      if (mounted) {
        const data = decodeJwtToken(jwtToken);
        setData(data);
  
        try {
          if (data.role === "entity") {
            await fetchOrgDataAndUpdate();
            setName(data?.name);
          } else if (data.role === "user") {
            await fetchDataAndUpdateUserData();
            setName(data?.first_name);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
  
        await fetchNotification(1); // Fetch once on mount
      }
    };
  
    fetchData();
  
    return () => {
      mounted = false;
    };
  }, [jwtToken]); // Consider memoizing or protecting jwtToken from unnecessary changes
  

  useEffect(() => {
    if (page > 1) {
      fetchNotification(page).finally(() => setLoadingMore(false));
    }
  }, [page]);

  const lastMessageElementRef = useCallback(
    (node) => {
      if (loadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreRef.current) {
          console.log("Ye wala function chal rha h.");
          setLoadingMore(true);
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loadingMore] // Don't include `hasMore` to avoid retrigger
  );
  

  const openMessage = (data) => {
    if (data?.type === "notice") {
      setMessageOpen(true);
      fetchNotificationById(data?._id, data?.read);
    }
  };

  const closeMessage = () => {
    setMessageOpen(false);
    setMessageById([]);
  };

  if (userData === null || isLoading) {
    return <Loader />;
  }

  const items = [
    {
      name: "Total Linked Loans",
      loans: `${dashboardData?.data?.linkedLoanCount}`,
      percent: "+3.48",
    },
    {
      name: "Loans in Default",
      loans: `${dashboardData?.data?.loanDefaultCount}`,
      percent: "+3.48",
    },
    {
      name: "Last Updated Date",
      loans: `${
        dashboardData?.data?.kycUpdated === true
          ? `${formatDate(userData?.updated_at)}`
          : "Not updated"
      }`,
      percent: "+3.48",
    },
  ];

  return (
    <>
      <div className="bg-bgclr8">
        <div className="container mx-auto">
          <div className="flex pt-6 pb-10 lg:mx-10 mx-2 gap-5">
            <div class=" hidden md:block">
              <Widget
                name={
                  `${userData?.first_name || ""} ${
                    userData?.middle_name || ""
                  } ${userData?.last_name || ""}`.trim() ||
                  `${userData?.name || ""}`
                }
                UCI={userData?.system_id}
              />
            </div>
            <div className="w-full">
              <div>
                <div className="text-[24px] font-[600] mb-5 mt-2 text-bgclr6">
                  <h1>Overview</h1>
                </div>
                <div className="grid lg:grid-cols-3 gap-5 mr-3">
                  {items.map((item, index) => (
                    <div className="bg-bgclr9 pl-5 pr-1 h-[140px] rounded-3xl shadow-xl">
                      <p className="text-[14px] text-[#A0AEC0] mt-5">
                        {item.name}
                      </p>
                      <h3 className="text-[18px] text-[#2D3748] font-[700]">
                        {item.loans}
                      </h3>
                      <div className="flex items-end mt-7">
                        <h2 className="text-[14px] text-[#48BB78] font-[700]">
                          {item.percent}
                        </h2>
                        <p className="text-[14px] text-[#A0AEC0] ml-3">
                          Since last month
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <div></div>
              </div>

              <div className="grid lg:grid-cols-2 mt-10 gap-5">
                <div className="rounded-xl bg-bgclr9 shadow-lg">
                  <div className="flex justify-between items-center text-[24px] px-3 font-[600] py-3 text-bgclr6 border-b">
                    <h1>Notifications</h1>
                    <div className="flex">
                      <IoIosNotifications size={30} />
                      {message?.count > 0 && (
                        <span className="flex justify-center items-center -mt-3 -ml-3 bg-red-600 text-white text-[15px] h-[25px] w-[25px] rounded-full">
                          {message?.count}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* Notifications */}
                  <div className="h-[35vh] overflow-y-auto">
                    {message.length <= 0 ? (
                      <div className="flex justify-center items-center">
                        <DashboardLoading />
                      </div>
                    ) : (
                      <div>
                        {message?.docs?.map((item, index) => {
                          const isLastItem = index === message.docs.length - 1;
                          return (
                            <button
                              ref={isLastItem ? lastMessageElementRef : null}
                              key={item._id}
                              onClick={() => openMessage(item)}
                              className={`pl-5 pr-1 text-left py-5 w-full border-b hover:bg-bgclr9 ${
                                !item.read ? "bg-slate-200" : "bg-bgclr9"
                              }`}
                            >
                              <div className="flex justify-between">
                                <h2 className="text-[14px] text-bgclr font-[700]">
                                  {item.type === "registration"
                                    ? `Welcome! ${name}`
                                    : `${item?.bankDetails?.name}`}
                                </h2>
                                <p className="text-[14px] text-[#A0AEC0] mx-3">
                                  {formatDate(item.updatedAt)}
                                </p>
                              </div>
                              <p className="text-[16px] text-[#A0AEC0] mt-3 mr-10">
                                {item.body.slice(0, 80)}...
                              </p>
                            </button>
                          );
                        })}

                        {loadingMore && <DashboardLoading />}
                      </div>
                    )}
                  </div>
                </div>
                <div className="rounded-xl bg-bgclr9 shadow-lg">
                  <div>
                    <div className="text-[24px] px-3 font-[600] py-3 text-bgclr6">
                      <h1>Calender</h1>
                    </div>
                    <div className="flex justify-center">
                      <Calendar onChange={onChange} value={value} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {messageOpen && (
        <NotificationModal
          messageOpen={messageOpen}
          closeMessage={closeMessage}
          messageById={messageById}
        />
      )}
    </>
  );
};

export default BorrowerDashboard;
